// extracted by mini-css-extract-plugin
export var button = "SingleInputForm-module--button--3c3cf";
export var copyInput = "SingleInputForm-module--copyInput--aa0e5";
export var focused = "SingleInputForm-module--focused--64093";
export var form = "SingleInputForm-module--form--f6dd5";
export var inputWrapper = "SingleInputForm-module--inputWrapper--e546a";
export var lottieContainer = "SingleInputForm-module--lottieContainer--8bc16";
export var small = "SingleInputForm-module--small--711f0";
export var wrapper = "SingleInputForm-module--wrapper--236da";